import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=f4273d7a&scoped=true&"
import script from "./Records.vue?vue&type=script&lang=js&"
export * from "./Records.vue?vue&type=script&lang=js&"
import style0 from "./Records.vue?vue&type=style&index=0&id=f4273d7a&prod&lang=scss&scoped=true&"
import style1 from "./Records.vue?vue&type=style&index=1&id=f4273d7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4273d7a",
  null
  
)

export default component.exports